import { render, staticRenderFns } from "./WebhooksView.vue?vue&type=template&id=09b4edd3&scoped=true"
import script from "./WebhooksView.vue?vue&type=script&lang=js"
export * from "./WebhooksView.vue?vue&type=script&lang=js"
import style0 from "./WebhooksView.vue?vue&type=style&index=0&id=09b4edd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4edd3",
  null
  
)

export default component.exports